export default {
  IRR: 'ریال',
  Tomans: 'تومان'
}
